// 監視オプション
const observerOptions = {
  rootMargin: '0px', //画面に入ったと認識させる距離
  threshold: 0.25, // 認識されてから実行までの時間
};

// 要素がビューポートに入ったら実行する関数
const addClassName = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('effected');
    }
  });
};

// 要素がビューポート（表示領域）とどう交差するか監視する
export const observer = new IntersectionObserver(addClassName, observerOptions);
